export class ToolbarOptionsConfig {
    fullScreen : boolean = true;
    constructor(){}
}
